import { HttpParams } from '@angular/common/http';
import { each, camelCase, snakeCase } from 'lodash';

const deepMapKeys = require('deep-map-keys');

let typeCache: { [label: string]: boolean } = {};

export function type<T>(label: T | ''): T {
  if (typeCache[<string>label]) {
    throw new Error(`Action type "${label}" is not unique"`);
  }

  typeCache[<string>label] = true;

  return <T>label;
}

export function objectToHttpParams(object: Object): HttpParams {
  let params = new HttpParams();
  each(object, (value, key) => {
    if (value || value === false || value === 0) {
      if (value instanceof Array) {
        value.forEach((value) => {
          params = params.append(key + '[]', value.toString());
        });
      } else {
        params = params.set(key, value.toString());
      }
    }
  });

  return params;
};

export function snakeizeParams(params: { [key: string]: any }): { [key: string]: any } {
  return deepMapKeys(params, (key, value) => (snakeCase(key)));
}

export function camelizeResponse(response: any): any {
  return deepMapKeys(response, (key, value) => (camelCase(key)));
};



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/util.ts